// If integrationA.name and integrationB.name belong to one of the same List in any order, they are considered
// approximately-equals by name.
import {List} from 'immutable';

export const INTEGRATION_NAME_APPROXIMATION_EQUALS = List([
  List(['Aircall']),
  List(['Dialpad']),
  List(['Dynamics']),
  List(['HubSpot']),
  List(['Outreach', 'OutreachIO', 'OutreachV2']),
  List(['Pipedrive']),
  List(['S3CSVFileHandler']),
  List(['Salesforce', 'SFDCScraper']),
  List(['SalesLoft']),
  List([
    'SFTPScraper',
    'SFTPCSVFileHandler',
    'SFTPFileHandler',
    'SFTPJSONFileHandler',
    'SFTPJSONFileHandler',
  ]),
  List(['SugarCRM']),
  List(['ZoomUs', 'ZoomV2']),
]);
